import * as S from './MainContent.styles';

export const MainContent = S.MainContent;
export const MainContentCenter = S.MainContentCenter;
